import { v4 as uuidv4 } from "uuid";
import { OOMenuItemTags } from "./oo-menu-tags.model";
import { OOVenue } from "./oo-venue";

export class OOTags {
	key: string = uuidv4();
	venueKey: number;
	name: string;
	severity: string;

	OOMenuItemTags: OOMenuItemTags[];

	OOVenue: OOVenue;

	unsaved: boolean;

	public constructor(init?: Partial<OOTags>) {
		Object.assign(this, init);
	}
}
